<div class="main-container" *ngIf="!isLoading && dockData" [ngStyle]="{ 'background-color': bgColor}">
  <h1 class="description" [ngStyle]="{'color': activeDock ? '#FFF' : '#000'}">{{dockData.description}}</h1>
  <app-takt [takt]="takt" [bgColor]="bgColor" [ngStyle]="{'color': activeDock ? '#FFF' : '#000'}"></app-takt>
  <div *ngIf=" !isLoading && tripDBData?.trip" class="boxes">
    <div class="arrival-group">
      <div class="arrival-box" [ngStyle]="getArrivalStyle()" *ngIf="!isExtraTrip">Chegada
        {{definedArrival}}</div>
      <div class="arrival-box" [ngStyle]="isExtraTrip ? {'background-color': 'transparent'} : getArrivalStyle()">
        Chegada real {{dockData.status | date: 'HH:mm:ss'}}
      </div>
    </div>
    <div class="info-group">
      <div class="info-box" *ngIf="isExtraTrip">VIAGEM EXTRA</div>
      <div class="info-box">{{processDescription}}</div>
    </div>
    <div class="departure-group" *ngIf="!isExtraTrip">
      <div class="departure-box" [ngStyle]="getDepartureStyle()">Saída {{definedDeparture}}</div>
      <div class="departure-box" [ngStyle]="getDepartureStyle()">Saída real
        {{remainingRealTimeFormatted}}</div>
    </div>
  </div>
  <button *ngIf="dockData.truck && tripDBData?.trip == 0 && !isViewOnly" (click)="visibilityClick()">Inserir viagem</button>
</div>

<div class="loading-container" *ngIf="isLoading">
  <div class="spinner"></div>
  <p>Carregando dados...</p>
</div>

<div *ngIf="showIntegrationForm" class="overlay" (click)="toggleIntegrationForm()">
  <app-motores-transmissao-integration-form [dockIdReceived]="dockId">
  </app-motores-transmissao-integration-form>
</div>
